import makeStyles from '@mui/styles/makeStyles';
import MatchSummaries from "components/Matching/MatchSummaries";
import Dialog from "components/redesign/Dialog";
import {History} from "lucide-react";
import {groupBy, isEmpty, map, toUpper} from 'lodash';
import moment from "moment";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {color, match, type} from "common/tokens";

const useStyles = makeStyles({
  block: {
    "& + &": {marginTop: 24},
  },
  date: {
    ...type.chipSmall,
    color: color.TEXT_MUTED,
    marginBottom: 8,
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    padding: '60px 0',
    ...type.meta,
    color: match.CHIP_MUTED_FG,
  },
});

const MatchingHistoryModal = ({open, handleState, getMatchesList, matches}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  useEffect(() => {
    open && getMatchesList()
  }, [open]);

  const groupedList = groupBy(matches, match => moment(match.updatedTimestamp).format('YYYY-MM-DD'));

  return (
    <Dialog open={open} onClose={handleState} title={t('matchingHistory')} maxWidth={560}>
      {isEmpty(groupedList) ? (
        <div className={classes.empty}>
          <History size={32} strokeWidth={1.75}/>
          {t('noMatchingHistory')}
        </div>
      ) : map(groupedList, (matchesForDate, date) => (
        <div key={date} className={classes.block}>
          <div className={classes.date}>{toUpper(moment(date).format('Do MMMM YYYY'))}</div>
          <MatchSummaries matches={matchesForDate} infoOnly showStatus showUserInfo={false}
                          showExpiryDuration={false}/>
        </div>
      ))}
    </Dialog>
  )
};

export default MatchingHistoryModal;
